import './style.scss'

import Title from 'components/Title'
import RichText from 'components/RichText'

import { mapGetters } from 'vuex'
import getPathFromUrl from 'util/getPathFromUrl'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'

export default {
  name: 'ContentList',
  props: ['componentData'],
  computed: {
    ...mapGetters(['lang'])
  },
  render (h) {
    const { componentData, lang } = this
    return (
      <ul class='ContentList'>
        {componentData && componentData.length
          ? (componentData.map(i => (
            <li class='ContentList__item'>

              <Title class='ContentList__item-title' id={i.section_title} level={2}>{i.section_title}</Title>

              <ul class='ContentList__sublist'>
                {i.list_items && i.list_items.length
                  ? (i.list_items.map(s => (

                    <li class='ContentList__sublist-item'>
                      {renderSublistLink(h, s, lang)}
                      <RichText content={s.content} />
                    </li>

                  )))
                : null}
              </ul>

            </li>
          )))
        : null}
      </ul>
    )
  }
}

function renderSublistLink (h, s, lang) {
  if (s.link_type === 'external_link') {
    return <a class='ContentList__sublist-item-title ContentList__sublist-item-title--link' href={s.external_link_url} target='_blank' rel='noopener'>{s.title}</a>
  } else if (s.link_type === 'internal_link') {
    return <router-link class='ContentList__sublist-item-title ContentList__sublist-item-title--link' to={verifyLeadingSlashLang(getPathFromUrl(s.internal_link), lang)}>{s.title}</router-link>
  } else if (s.link_type === 'file') {
    return <a class='ContentList__sublist-item-title ContentList__sublist-item-title--link' href={s.file_link} target='_blank' rel='noopener'>{s.title}</a>
  } else {
    return <Title class='ContentList__sublist-item-title' id={s.title} level={2}>{s.title}</Title>
  }
}



// WEBPACK FOOTER //
// ./client/components/ContentList/index.js